import { render, staticRenderFns } from "./TimeframeInput.vue?vue&type=template&id=b1c97b3a&scoped=true&"
import script from "./TimeframeInput.vue?vue&type=script&lang=js&"
export * from "./TimeframeInput.vue?vue&type=script&lang=js&"
import style0 from "./TimeframeInput.vue?vue&type=style&index=0&id=b1c97b3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c97b3a",
  null
  
)

export default component.exports